// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2256":"1ae3eb7b","2287":"95b8831b","3426":"95b8831b","4260":"95b8831b","4665":"95b8831b","8759":"95b8831b","9957":"95b8831b"}[chunkId] + ".chunk.css";
};